import { useContext } from 'react'

import { LineChartContext } from './line-chart-context'

export const useLineChart = () => {
  const context = useContext(LineChartContext)

  if (!context) {
    throw new Error('LineChart components must be used within a LineChart component')
  }

  return context
}
